<template>
  <div>
    <div style="min-height: calc(100vh - 88px);">
      <el-main :style="{ height: height + 'px' }" style="overflow:auto"
        :infinite-scroll-disabled="disabled">
        <div class="Scroll_content">
          <div class="titleinder_content">
            <div class="simkeropl">{{ $t('videoClass.title') }}
              <div class="left_right_rili">
                <el-date-picker v-model="value2" type="month" :placeholder="$t('videoClass.selectMonth')" @change="get_time"
                  value-format="yyyy-MM">
                </el-date-picker>
              </div>
            </div>
          </div>

          <div class="noResultInfo" v-if="classItems && classItems.length == 0">
            <img src="../../assets/nodata.png" alt="">
            <p class="font_16 color_grey2" style="margin-top: 24px;">{{ $t('videoClass.emptyMonth') }}</p>
          </div>
          <div v-else>
            <div v-for="(item, index) in classItems" :key="index" class="item_class" @click="toDetail(item)">
              <img :src="item.cover_path" alt="" class="img_item">
              <div>
                <div class="t1_r_item">
                  <p class="t1_r_item_p">{{ item.title }}</p>
                  <span :style="{ 'background-color': item.bgColor, 'color': item.customColor }"
                    class="t1_r_item_span">
                    {{ $t('videoClass.statusLabel') }}: {{ $t(item.statusTextKey) }} ({{ $t('videoClass.classTime') }}: {{ $t('videoClass.anytime') }})</span>
                  <span :style="{ 'color': item.color }" class="t1_r_item_span2">{{ $t('videoClass.learned') }}:{{ item.progress}}</span>
                  <el-progress :percentage="item.pro" :color="item.customColor" define-back-color="#E5E7EB"
                    style="width: 160px" :stroke-width="4" :show-text="false"></el-progress>
                </div>
                <p class="t2_r_item">
                    {{ $t('videoClass.introColon') }} {{ item.introductory }}
                </p>
                <p class="t2_r_item">
                  订购时间：{{ item.order_time }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="mg_tinmqx" v-if="is_show"> {{ $t('reached') }}</div>
      </el-main>
    </div>
  </div>
</template>

<script>
import { setStore, getStore, keys } from '@/store';
import IndexFooter from '../views/footer'
import MyScheduled from '../views/scheduled'
import MyCourse from '../views/course'
import PastLesson from '../views/lesson'
//引入header组件
import Header from '../header/header'
export default {
  name: 'Videoclass',
  components: {
    IndexFooter,
    MyScheduled,
    PastLesson,
    MyCourse,
    Header
  },
  data() {
    return {
      classItems: [],
      height: 100,
      tableData: [],
      value2: '',
      totle: null,
      pagesize: 10,
      page: 1,
      student_sn: '',
      disabled: false,
      currentPage: 1,
      is_show: false,
    }
  },
  created() {
    let height = document.body.offsetHeight - 104;
    this.height = height
    if (getStore(keys.token)) {
      if (getStore(keys.userInfo).status == 0) {
        this.$router.push({
          path: '/onboarding'
        })
      }
    } else {
      this.$router.push({
        path: '/'
      })
      return false
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    //获取列表
    getList(){
      this.$http.get('/api/vodList?month=' + this.value2).then(res => {
        res.data.data.forEach(ele => {
          ele.statusTextKey = this.utils.getStatusText(ele.status)
          ele.customColor =  ele.status == 1 ? '#999999' : ele.status == 2 ? '#B50604' : '#69A635'
          ele.bgColor =  ele.status == 1 ? '#EEEEEE' : ele.status == 2 ? '#B5060433' : '#69A63533'
          ele.pro =  (((ele.progress.split('/')[0] / ele.progress.split('/')[1]))*100).toFixed(0) - 0

        })
        this.classItems = res.data.data
      })
    },
    //跳转详情
    toDetail(item) {
      this.$router.push('/class-detail?id='+ item.id)
    },
    get_time(val) {
      this.value2 = val
      this.getList()
    }
  },
  watch: {

  },
}
</script>

<style scoped lang="less">
.noResultInfo {
  margin-top: 80px;
  text-align: center;

  p {
    margin-bottom: 32px;
  }
}

.simkeropl {
  font-family: Sofia Pro;
  font-style: normal;
  font-weight: bold;
  font-size: 33px;
  color: #000000;
  margin-bottom: 24px;
}

.titleinder_content {
  width: 100%;
  overflow: hidden;
}

.left_right_rili {
  float: right;
}

.mg_tinmqx {
  margin-top: 40px;
  margin-bottom: 40px;
  font-size: 18px;
  line-height: 27px;
  color: #A5A5A5;
  text-align: center;
}
.item_class{
cursor: pointer;padding: 12px 40px 12px 12px;display: flex;flex-direction: row;background-color: #fff;margin-bottom: 12px;
}
.img_item{
  width: 160px;height: 100px;border-radius: 4px;margin-right: 16px;min-width: 160px;min-height: 100px;
}
.t1_r_item{
display: flex;flex-direction: row;margin-bottom: 4px;align-items: center;
}
.t2_r_item{
  font-size: 14px;color: #666;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 24px;
}
.t1_r_item_p{
  font-size: 16px;font-weight: 500;color: #333;margin-right: 10px;
}
.t1_r_item_span{
font-size: 12px;display: inline-block;padding: 5px 8px;border-radius: 4px;margin-right: 10px;
}
.t1_r_item_span2{
margin-right: 10px;font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/children/Videoclass.vue